export default {
  setAgreements: (state, agreements) => {
    state.agreements = agreements;
  },
  setError: (state, err) => {
    state.error = err;
  },
};
